<Dialog modal :header="title" v-model:visible="visibleModel">
    <form class="vl-form" id="edit-invoice-settings-form">
        <p>InvoiceSettingId: <strong>{{ settings.invoiceSettingsId }}</strong></p>
        <div class="aeg-form-layout">
            <div class="aeg-label-above-layout">
                <aeg-field-validation-wrapper
                    :error-message="errors.invoiceReference"
                    name="Eigen referentie"
                    #default="{hasErrors}"
                    annotation="Eventueel bestelbonnummer / PO-nummer dat op toekomstige PostPaid facturen geplaatst zal worden (max. 35 karakters)"
                >
                    <InputText
                        name="invoiceReference"
                        v-model="invoiceReference"
                        v-bind="invoiceReferenceProps"
                        :invalid="hasErrors"
                        placeholder="Eigen referentie (optioneel)"
                    />
                </aeg-field-validation-wrapper>
            </div>
            <div class="aeg-label-above-layout">
                <aeg-field-validation-wrapper
                    :error-message="errors.forTheAttentionOf"
                    name="T.a.v."
                    #default="{hasErrors}"
                    annotation="Eventuele 'Ter attentie van'-waarde die op toekomstige PostPaid facturen geplaatst zal worden"
                >
                    <InputText
                        name="forTheAttentionOf"
                        v-model="forTheAttentionOf"
                        v-bind="forTheAttentionOfProps"
                        :invalid="hasErrors"
                        placeholder="Ter attentie van (optioneel)"
                    />
                </aeg-field-validation-wrapper>
            </div>
        </div>
    </form>

    <template v-slot:footer>
        <Button :disabled="invalidForm || isSaving" type="submit">
            {{ isSaving ? 'Bezig met opslaan...' : 'Wijzigingen opslaan' }}
        </Button>
        <aeg-cancel-button @click="onCloseModal" />
    </template>
</Dialog>
